// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__r4mrr","label":"Category_label__18X0c","content":"Category_content__xBvBx","header":"Category_header__2exwC","location":"Category_location__yi9yz"};